module.exports = __webpack_public_path__ + "static/img/lc.1210839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sunShine/lc.png
// module id = 2Yy+
// module chunks = 1